import { Content, Header, Page } from '@backstage/core-components';
import {
  CatalogFilterLayout,
  EntityKindPicker,
  EntityLifecyclePicker,
  EntityListProvider,
  EntityOwnerPicker,
  EntityTypePicker,
} from '@backstage/plugin-catalog-react';
import { AwsAccountsTable } from './AwsAccountsTable';
import {
  AwsAccountBusinessOwnerPicker,
  AwsAccountProjectManagerPicker,
  AwsAccountSystemPicker,
  AwsAccountTechOwnerPicker,
} from './pickers';

/**
 * D1 — the AWS Accounts dashboard (feature 0010): a filterable inventory of
 * every `aws-account` Resource discovered by feature 0009.
 *
 * Kind/type are pinned (hidden) to `resource` / `aws-account`. Five user
 * filters, each multi-select and AND-combined by the list context: env
 * (lifecycle) and owner via the stock pickers (server-side facets), and System,
 * tech owner, and project manager via custom client-side predicate filters
 * (the owner-role annotations are comma-joined strings and System is a relation,
 * so neither is a clean server facet — and the aws-account set is small).
 *
 * Visible to all authenticated users — it surfaces only catalog data already
 * shown on the entity pages.
 */
export const AwsAccountsPage = () => (
  <Page themeId="home">
    <Header
      title="AWS Accounts"
      subtitle="Discovered AWS accounts across all Systems"
    />
    <Content>
      <EntityListProvider>
        <CatalogFilterLayout>
          <CatalogFilterLayout.Filters>
            <EntityKindPicker initialFilter="resource" hidden />
            <EntityTypePicker initialFilter="aws-account" hidden />
            <EntityLifecyclePicker />
            <EntityOwnerPicker />
            <AwsAccountSystemPicker />
            <AwsAccountBusinessOwnerPicker />
            <AwsAccountTechOwnerPicker />
            <AwsAccountProjectManagerPicker />
          </CatalogFilterLayout.Filters>
          <CatalogFilterLayout.Content>
            <AwsAccountsTable />
          </CatalogFilterLayout.Content>
        </CatalogFilterLayout>
      </EntityListProvider>
    </Content>
  </Page>
);
